import * as React from 'react';
import { Input } from './input';

interface TimePickerProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export const TimePicker = React.forwardRef<HTMLInputElement, TimePickerProps>(
  ({ value, onChange, disabled }, ref) => {
    return (
      <Input
        ref={ref}
        type="time"
        value={value || ''}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        className="w-full"
      />
    );
  }
);

TimePicker.displayName = 'TimePicker';
